import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TaskDetailModal } from "./-pages/TaskDetailPage";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/tasks/$taskId")({
  component: RouteComponent,
  loader: async ({ params }) => {
    // Pre-load task details and configuration
    const [task, config] = await Promise.all([
      queryClient.fetchQuery(trpc.tasks.get.queryOptions({ id: params.taskId })),
      queryClient.fetchQuery(trpc.tasksConfig.getEffective.queryOptions()),
    ]);
    return { task, config };
  },
});

function RouteComponent() {
  const { task, config } = Route.useLoaderData();
  const { datasetSlug } = Route.useParams();
  const navigate = useNavigate();
  
  useBreadCrumbs([
    { title: "Tasks", link: `/${datasetSlug}/tasks` },
    { title: task?.title || "Task", link: `/${datasetSlug}/tasks/${task?.id}` },
  ]);

  const handleClose = () => {
    navigate({ to: "/$datasetSlug/tasks", params: { datasetSlug } });
  };

  return (
    <TaskDetailModal
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          handleClose();
        }
      }}
      task={task}
      config={config}
    />
  );
}